import { Tooltip } from '@mui/material';
import React, { ReactElement } from 'react';

type CustomTooltipProps = {
  title?: string | JSX.Element,
  children: ReactElement,
}
export const CustomTooltip = ({
  title,
  children,
}: CustomTooltipProps):JSX.Element | null => {
  if (title) {
    return (
      <Tooltip title={ title } placement="top">
        {children}
      </Tooltip>
    );
  }

  return null;
};

CustomTooltip.defaultProps = {
  title: '',
};
